import {useLocale} from 'next-intl'

import {Locale} from '@/utils/constants'

export const isLocale = (value: string | undefined): value is Locale =>
  Object.values(Locale).includes(value as Locale)

export const getLanguage = (language: string) => (isLocale(language) ? language : Locale.en)

export const useLanguage = () => {
  const locale = useLocale()
  return getLanguage(locale)
}
